export default [
  {
    path: '/modules/financial/mensalidades',
    name: 'mensalidades-dashboard',
    component: () => import('@/views/modules/financial/mensalidades/MensalidadesDashboard.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Gestão de Contribuições',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contribuições', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/mensalidades/tipo-faixa',
    name: 'mensalidades-tipo-faixa',
    component: () => import('@/views/settings/financial/TipoFaixaSetting.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Tipos de Faixa',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contribuições', to: { name: 'mensalidades-dashboard' } },
        { text: 'Tipos de Faixa', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/mensalidades/vigencia',
    name: 'mensalidades-vigencia',
    component: () => import('@/views/settings/financial/PeriodoVigenciaSetting.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Períodos de Vigência',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contribuições', to: { name: 'mensalidades-dashboard' } },
        { text: 'Períodos de Vigência', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/mensalidades/matriz',
    name: 'mensalidades-matriz',
    component: () => import('@/views/settings/financial/MatrizValoresSetting.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Matriz de Valores',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contribuições', to: { name: 'mensalidades-dashboard' } },
        { text: 'Matriz de Valores', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/mensalidades/logs',
    name: 'mensalidades-logs',
    component: () => import('@/views/modules/financial/mensalidades/LogGeracaoList.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Histórico de Geração',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contribuições', to: { name: 'mensalidades-dashboard' } },
        { text: 'Histórico', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/mensalidades/logs/:id',
    name: 'mensalidades-log-detalhe',
    component: () => import('@/views/modules/financial/mensalidades/LogGeracaoReport.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Relatório de Geração',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contribuições', to: { name: 'mensalidades-dashboard' } },
        { text: 'Histórico', to: { name: 'mensalidades-logs' } },
        { text: 'Relatório', active: true },
      ],
    },
  },
]
